export default __webpack_public_path__ + "beta-maps-guides-migrate-expressions-1200-4cda900f2dd7cfa1e5e642f2809e272e.png";